( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.publication-grid' ).length ) {
        $( '.publication-grid' ).each( function( index, element ) {
          let lightboxTrigger;

          $( element ).magnificPopup( {
            delegate: '.publication-grid__trigger',
            type: 'image',
            mainClass: 'publication-grid__lightbox',
            closeOnContentClick: false,
            closeBtnInside: false,
            fixedContentPos: true,
            autoFocusLast: false,
            gallery: {
              enabled: true,
            },
            image: {
              titleSrc: 'title',
            },
            callbacks: {
              beforeOpen: function() {
                lightboxTrigger = this.st.el?.[0];
              },
              afterClose: function() {
                lightboxTrigger?.focus( {preventScroll: true} );
              },
            },
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'publication-grid', COMPONENT );
} )( app );
